import camelcaseKeys from "camelcase-keys";
import api from "./api";

export function getBraintreeToken() {
  return api
    .get(`/braintree/token`)
    .then((res) => camelcaseKeys(res.data, { deep: true }));
}
